/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SvgFileMetadataList } from '../../models/svg-file-metadata-list';

export interface GetStationSvgFilesMetadata$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * If client type user can access
 */
  accessClient: boolean;
}

export function getStationSvgFilesMetadata(http: HttpClient, rootUrl: string, params: GetStationSvgFilesMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<SvgFileMetadataList>> {
  const rb = new RequestBuilder(rootUrl, getStationSvgFilesMetadata.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('accessClient', params.accessClient, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SvgFileMetadataList>;
    })
  );
}

getStationSvgFilesMetadata.PATH = '/stations/{uid}/svg';
